import { UIHeroTheme, UIHeroGenre } from './types/ui';
import {rem} from 'csx';

export const LICKD_YOUTUBE_CHANNEL_ID = 'UCcyDVcv2mByysfO0i1GjTqA';

export const SIGNIN_URL = '/signin';

export const GOLDEN_TICKET_KEY = 'is_golden_ticket';
export const REFERRER_CHANNEL_KEY = 'referrerChannelId';
export const PREFERRED_GENRE = 'preferred_genre';

export const SIGN_UP_ACTION_QUERY = 'show-sign-up';

export const JAACKMAATE_URL = '/jaackmaate';
export const JAACKMAATE_UTM_MEDIUM = 'referral';
export const JAACKMAATE_UTM_SOURCE = 'podcast';
export const JAACKMAATE_UTM_CAMPAIGN = 'jaackmaate-podcast';

export const VIDSUMMIT_URL = '/vidsummit'
export const VIDSUMMIT_UTM_SOURCE = 'vidsummit';
export const VIDSUMMIT_UTM_MEDIUM = 'vidsummit';
export const VIDSUMMIT_UTM_CAMPAIGN = 'vidsummit';

export const BLOGOSPHERE_URL = '/blogosphere'
export const BLOGOSPHERE_UTM_SOURCE = 'blogosphere';
export const BLOGOSPHERE_UTM_MEDIUM = 'blogosphere';
export const BLOGOSPHERE_UTM_CAMPAIGN = 'blogosphere';

export const VIDCON_URL = '/vidconlondon2020'
export const VIDCON_UTM_SOURCE = 'vidconlondon2020';
export const VIDCON_UTM_MEDIUM = 'vidconlondon2020';
export const VIDCON_UTM_CAMPAIGN = 'vidconlondon2020';

export const FULLSCREEN_URL = '/fullscreen'
export const TUBEBUDDY_URL = '/tubebuddy'
export const FULLSCREEN_UTM_SOURCE = 'fullscreen';
export const FULLSCREEN_UTM_MEDIUM = 'referral';
export const FULLSCREEN_UTM_CAMPAIGN = 'fullscreen-dashboard';

export const SESSION_LOGIN_REDIRECT = 'lickd_login';

export const YOUTUBE_THEMES: Array<UIHeroTheme> = [{"icon":{},"label":"Auto & Vehicles","slug":"auto-and-vehicles"},{"icon":{},"label":"Beauty & Fashion","slug":"beauty-and-fashion"},{"icon":{},"label":"Comedy","slug":"comedy"},{"icon":{},"label":"Education","slug":"education"},{"icon":{},"label":"Entertainment","slug":"entertainment"},{"icon":{},"label":"Film & Animation","slug":"film-and-animation"},{"icon":{},"label":"Food","slug":"food"},{"icon":{},"label":"Gaming","slug":"gaming"},{"icon":{},"label":"How-to & Style","slug":"how-to-and-style"},{"icon":{},"label":"Music","slug":"music"},{"icon":{},"label":"Pets & Animals","slug":"pets-and-animals"},{"icon":{},"label":"Science & Technology","slug":"science-and-technology"},{"icon":{},"label":"Sport","slug":"sport"},{"icon":{},"label":"Travel & Events","slug":"travel-and-events"}];

export const GENRES: Array<UIHeroGenre> = [{"label":"Breakbeat","slug":"breakbeat"},{"label":"Drum & Bass","slug":"drum-and-bass"},{"label":"Dubstep","slug":"dubstep"},{"label":"Folk","slug":"folk"},{"label":"House","slug":"house"},{"label":"Indie","slug":"indie"},{"label":"Pop","slug":"pop"},{"label":"Punk","slug":"punk"},{"label":"Remixes","slug":"remixes"},{"label":"Rock","slug":"rock"}];

export const ONBOARDING_STATE = {
  EMAIL_UNCONFIRMED: 'email_unconfirmed',
  SPOTIFY_UNLINKED: 'spotify_unlinked',
  TWITTER_UNLINKED: 'twitter_unlinked',
  ONBOARDING_COMPLETE: 'onboarding_complete',
};

export const CHECKOUT_STEPS = [
  'review',
  'payment',
  'confirm',
  'download'
];

export const ENGLISH_COUNTRIES: Array<string> = [
  'US',
  'CA',
  'GB',
  'AU'
];

export const BASE_PX = 16;
export const BASE_RHYTHM = rem(1.25);
export const MAX_PAGE_WIDTH = 64 * 16;

export const COUNTRIES: {[code: string]: string} = {
  AF: "Afghanistan",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AG: "Angola",
  AI: "Anguilla",
  // AG: "Antigua &amp; Barbuda",
  AR: "Argentina",
  AA: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BL: "Bonaire",
  BA: "Bosnia &amp; Herzegovina",
  BW: "Botswana",
  BR: "Brazil",
  BC: "British Indian Ocean Ter",
  BN: "Brunei",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  IC: "Canary Islands",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CD: "Channel Islands",
  CL: "Chile",
  CN: "China",
  CI: "Christmas Island",
  CS: "Cocos Island",
  CO: "Colombia",
  CC: "Comoros",
  CG: "Congo",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CT: "Cote D'Ivoire",
  HR: "Croatia",
  // CU: "Cuba",
  CB: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  TM: "East Timor",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FA: "Falkland Islands",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  FS: "French Southern Ter",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GN: "Guinea",
  GY: "Guyana",
  HT: "Haiti",
  HW: "Hawaii",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  // IA: "Iran",
  IQ: "Iraq",
  IR: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  // NK: "Korea North",
  KS: "Korea South",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Laos",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macau",
  MK: "Macedonia",
  MG: "Madagascar",
  MY: "Malaysia",
  MW: "Malawi",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  ME: "Mayotte",
  MX: "Mexico",
  MI: "Midway Islands",
  MD: "Moldova",
  MC: "Monaco",
  MN: "Mongolia",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Nambia",
  NU: "Nauru",
  NP: "Nepal",
  AN: "Netherland Antilles",
  NL: "Netherlands (Holland, Europe)",
  NV: "Nevis",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NW: "Niue",
  NF: "Norfolk Island",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau Island",
  PS: "Palestine",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PO: "Pitcairn Island",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  // ME: "Republic of Montenegro",
  // RS: "Republic of Serbia",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russia",
  RW: "Rwanda",
  NT: "St Barthelemy",
  EU: "St Eustatius",
  HE: "St Helena",
  KN: "St Kitts-Nevis",
  LC: "St Lucia",
  MB: "St Maarten",
  PM: "St Pierre &amp; Miquelon",
  VC: "St Vincent &amp; Grenadines",
  SP: "Saipan",
  SO: "Samoa",
  // AS: "Samoa American",
  SM: "San Marino",
  ST: "Sao Tome &amp; Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  OI: "Somalia",
  ZA: "South Africa",
  ES: "Spain",
  LK: "Sri Lanka",
  // SD: "Sudan",
  SR: "Suriname",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  // SY: "Syria",
  TA: "Tahiti",
  TW: "Taiwan",
  TJ: "Tajikistan",
  TZ: "Tanzania",
  TH: "Thailand",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad &amp; Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TU: "Turkmenistan",
  TC: "Turks &amp; Caicos Is",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VS: "Vatican City State",
  VE: "Venezuela",
  VN: "Vietnam",
  VB: "Virgin Islands (Brit)",
  VA: "Virgin Islands (USA)",
  WK: "Wake Island",
  WF: "Wallis &amp; Futana Is",
  YE: "Yemen",
  ZR: "Zaire",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

export const LANGUAGES: {[code: string]: string} = {
  'ab': 'Abkhazian',
  'aa': 'Afar',
  'af': 'Afrikaans',
  'ak': 'Akan',
  'sq': 'Albanian',
  'am': 'Amharic',
  'ar': 'Arabic',
  'an': 'Aragonese',
  'hy': 'Armenian',
  'as': 'Assamese',
  'av': 'Avaric',
  'ae': 'Avestan',
  'ay': 'Aymara',
  'az': 'Azerbaijani',
  'bm': 'Bambara',
  'ba': 'Bashkir',
  'eu': 'Basque',
  'be': 'Belarusian',
  'bn': 'Bengali',
  'bh': 'Bihari languages',
  'bi': 'Bislama',
  'bs': 'Bosnian',
  'br': 'Breton',
  'bg': 'Bulgarian',
  'my': 'Burmese',
  'ca': 'Catalan, Valencian',
  'km': 'Central Khmer',
  'ch': 'Chamorro',
  'ce': 'Chechen',
  'ny': 'Chichewa, Chewa, Nyanja',
  'zh': 'Chinese',
  'cu': 'Church Slavic, Church Slavonic, Old Church Slavonic, Old Slavonic, Old Bulgarian',
  'cv': 'Chuvash',
  'kw': 'Cornish',
  'co': 'Corsican',
  'cr': 'Cree',
  'hr': 'Croatian',
  'cs': 'Czech',
  'da': 'Danish',
  'dv': 'Divehi, Dhivehi, Maldivian',
  'nl': 'Dutch, Flemish',
  'dz': 'Dzongkha',
  'en': 'English',
  'eo': 'Esperanto',
  'et': 'Estonian',
  'ee': 'Ewe',
  'fo': 'Faroese',
  'fj': 'Fijian',
  'fl': 'Filipino',
  'fi': 'Finnish',
  'fr': 'French',
  'ff': 'Fulah',
  'gd': 'Gaelic, Scottish Gaelic',
  'gl': 'Galician',
  'lg': 'Ganda',
  'ka': 'Georgian',
  'de': 'German',
  'el': 'Greek (modern)',
  'gn': 'Guaraní',
  'gu': 'Gujarati',
  'ht': 'Haitian, Haitian Creole',
  'ha': 'Hausa',
  'he': 'Hebrew (modern)',
  'hz': 'Herero',
  'hi': 'Hindi',
  'ho': 'Hiri Motu',
  'hu': 'Hungarian',
  'is': 'Icelandic',
  'io': 'Ido',
  'ig': 'Igbo',
  'id': 'Indonesian',
  'ia': 'Interlingua',
  'ie': 'Interlingue',
  'iu': 'Inuktitut',
  'ik': 'Inupiaq',
  'ga': 'Irish',
  'it': 'Italian',
  'ja': 'Japanese',
  'jv': 'Javanese',
  'kl': 'Kalaallisut, Greenlandic',
  'kn': 'Kannada',
  'kr': 'Kanuri',
  'ks': 'Kashmiri',
  'kk': 'Kazakh',
  'ki': 'Kikuyu, Gikuyu',
  'rw': 'Kinyarwanda',
  'ky': 'Kirghiz, Kyrgyz',
  'kv': 'Komi',
  'kg': 'Kongo',
  'ko': 'Korean',
  'kj': 'Kuanyama, Kwanyama',
  'ku': 'Kurdish',
  'lo': 'Lao',
  'la': 'Latin',
  'lv': 'Latvian',
  'li': 'Limburgan, Limburger, Limburgish',
  'ln': 'Lingala',
  'lt': 'Lithuanian',
  'lu': 'Luba-Katanga',
  'lb': 'Luxembourgish, Letzeburgesch',
  'mk': 'Macedonian',
  'mg': 'Malagasy',
  'ms': 'Malay',
  'ml': 'Malayalam',
  'mt': 'Maltese',
  'gv': 'Manx',
  'mi': 'Maori',
  'mr': 'Marathi',
  'mh': 'Marshallese',
  'mn': 'Mongolian',
  'na': 'Nauru',
  'nv': 'Navajo, Navaho',
  'ng': 'Ndonga',
  'ne': 'Nepali',
  'nd': 'North Ndebele',
  'se': 'Northern Sami',
  'no': 'Norwegian',
  'nb': 'Norwegian Bokmål',
  'nn': 'Norwegian Nynorsk',
  'oc': 'Occitan',
  'oj': 'Ojibwa',
  'or': 'Oriya',
  'om': 'Oromo',
  'os': 'Ossetian, Ossetic',
  'pi': 'Pali',
  'pa': 'Panjabi, Punjabi',
  'ps': 'Pashto, Pushto',
  'fa': 'Persian',
  'pl': 'Polish',
  'pt': 'Portuguese',
  'qu': 'Quechua',
  'ro': 'Romanian, Moldavian, Moldovan',
  'rm': 'Romansh',
  'rn': 'Rundi',
  'ru': 'Russian',
  'sm': 'Samoan',
  'sg': 'Sango',
  'sa': 'Sanskrit',
  'sc': 'Sardinian',
  'sr': 'Serbian',
  'sn': 'Shona',
  'ii': 'Sichuan Yi, Nuosu',
  'sd': 'Sindhi',
  'si': 'Sinhala, Sinhalese',
  'sk': 'Slovak',
  'sl': 'Slovenian',
  'so': 'Somali',
  'nr': 'South Ndebele',
  'st': 'Southern Sotho',
  'es': 'Spanish, Castilian',
  'su': 'Sundanese',
  'sw': 'Swahili',
  'ss': 'Swati',
  'sv': 'Swedish',
  'tl': 'Tagalog',
  'ty': 'Tahitian',
  'tg': 'Tajik',
  'ta': 'Tamil',
  'tt': 'Tatar',
  'te': 'Telugu',
  'th': 'Thai',
  'bo': 'Tibetan',
  'ti': 'Tigrinya',
  'to': 'Tonga (Tonga Islands)',
  'ts': 'Tsonga',
  'tn': 'Tswana',
  'tr': 'Turkish',
  'tk': 'Turkmen',
  'tw': 'Twi',
  'ug': 'Uighur, Uyghur',
  'uk': 'Ukrainian',
  'ur': 'Urdu',
  'uz': 'Uzbek',
  've': 'Venda',
  'vi': 'Vietnamese',
  'vo': 'Volapük',
  'wa': 'Walloon',
  'cy': 'Welsh',
  'fy': 'Western Frisian',
  'wo': 'Wolof',
  'xh': 'Xhosa',
  'yi': 'Yiddish',
  'yo': 'Yoruba',
  'za': 'Zhuang, Chuang',
  'zu': 'Zulu'
};

export enum ImageSize {
  XLARGE = 'xlarge',
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
  XSMALL = 'xsmall',
}

export enum ImageAspect {
  WIDESCREEN = 16/10,
  TV = 4/3,
  BOX = 1
}

export const ImageSizeValue: {[key in ImageSize]: number} = {
  xlarge: 2400,
  large: 1200,
  medium: 760,
  small: 390,
  xsmall: 64,
};

export const KNOWN_COOKIES = [
  'utm_campaign',
  'utm_medium',
  'utm_source',
  'hsCtaTracking',
  REFERRER_CHANNEL_KEY,
  'is_lsylive',
  GOLDEN_TICKET_KEY,
  PREFERRED_GENRE,
  'mcn_user_id',
  'mcn_token',
  'mcn_name',
];